<template>
  <ModelEditFormPriceAgreement
    class="model-edit-form-known-business-entity-sale-item"
    v-model="priceAgreement"
    :is-retrieving="isRetrieving"
    :project="project"
    variant="businessEntity"
    show-surcharge-modifier
    framed
    @input="wasChanged = true"
    @surcharge-input="wasChanged = true"
  />
</template>
<script setup lang="ts">
import { Project } from "@/models/project.model"
import type { SaleItem } from "@/models/sale-item.model"
import { useModelEditFormPriceAgreementManager } from "@/composables/administration/model-edit-form-project-price-agreement-manager"
import { inject } from "vue"
import { KnownBusinessEntitySaleItem } from "@/models/known-business-entity-sale-item.model.ts"
import { useKnownBusinessEntitiesSaleItemsStore } from "@/store/known-business-entities-sale-items.store.ts"
import ModelEditFormPriceAgreement from "@/components/model_edit_form/ModelEditFormPriceAgreement.vue"

const props = defineProps<{
  project: Project
  saleItem: SaleItem
}>()

const { priceAgreement, savePriceAgreement, isRetrieving, wasChanged } =
  useModelEditFormPriceAgreementManager<SaleItem, KnownBusinessEntitySaleItem>(
    props.project,
    props.saleItem,
    useKnownBusinessEntitiesSaleItemsStore(),
    inject("knownBusinessEntitySaleItemController")!,
    KnownBusinessEntitySaleItem
  )

defineExpose({ savePriceAgreement })
</script>
